import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { isSupabaseConfigured } from "@/services/supabase-client.service";
import {
    getRequestStats,
    subscribeToRequests,
} from "@/services/care-practice-request.service";

export const careRequestKeys = {
    all: ["care-requests"] as const,
    stats: (practiceId?: string) => [...careRequestKeys.all, "stats", practiceId].filter(Boolean),
};

export function useCareRequestStatsQuery(practiceId?: string) {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!practiceId || !isSupabaseConfigured()) return;

        const sub = subscribeToRequests(practiceId, () => {
            void queryClient.invalidateQueries({
                queryKey: careRequestKeys.stats(practiceId),
            });
        });

        return () => sub.unsubscribe();
    }, [practiceId, queryClient]);

    return useQuery({
        queryKey: careRequestKeys.stats(practiceId),
        queryFn: () => getRequestStats(practiceId!),
        enabled: !!practiceId,
        staleTime: 30_000,
    });
}
